import { render, staticRenderFns } from "./siteDt.vue?vue&type=template&id=2e875ac6&scoped=true&"
import script from "./siteDt.vue?vue&type=script&lang=js&"
export * from "./siteDt.vue?vue&type=script&lang=js&"
import style0 from "./siteDt.vue?vue&type=style&index=0&id=2e875ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e875ac6",
  null
  
)

export default component.exports